import React from 'react'
import header from "../../asset/images/header1.png";
import playstore from "../../asset/images/playstore.png";
import recharge from "../../asset/images/recharge.png";
import secure from "../../asset/images/secure.png";
import transaction from "../../asset/images/transaction.png";
import selectPlan from "../../asset/images/select-plan.png";
import pay from "../../asset/images/pay.png";
import instantRecharge from "../../asset/images/instant-recharge.png";
import mobile from "../../asset/images/mobile.png";
import logo from "../../asset/images/logo.png";


import "../home/home.css";
import GetStarted from './GetStarted';
import Footer from './Footer';


export default function Home() {
  return (
    <div>
      {/* Naviagtion menu */}
        <nav style={{display:'flex',justifyContent:"space-between", padding:"10px 30px", backgroundColor:"white",alignItems:"center"}}>
         <div style={{display:"flex",alignItems:"center",alignContent:"center",flexDirection:"row-reverse",gap:"8px"}}>
           <p style={{color:"blue",margin:"0 0 5px 0"}}>Mani Vasu</p>
          <img src={logo} alt="" style={{width:"50px"}}/>
         </div>
          <list className="hidden">
            <ul style={{display:'flex',gap:"20px" }}>
              <li  ><a style={{color:"black",textDecoration:"none",fontFamily:"sans-serif"}} href='#features'>Features</a></li>
              <li><a style={{color:"black",textDecoration:"none",fontFamily:"sans-serif"}} href='#benefits'>Benefit</a></li>
              <li><a  style={{color:"black",textDecoration:"none",fontFamily:"sans-serif"}} href='#download'>Download</a></li>
            </ul>
          </list>
          <a  href='#get-started' style={{backgroundColor:"#007bff",color:"white",borderRadius:"8px",padding:"10px 15px 10px 15px",textDecoration:'none'}}>Get Started</a>
        </nav>
      {/* header section */}

      <div id= "download"style={{padding:"180px 0px 0px 50px", backgroundImage: `url(${header})`,backgroundSize: "cover",backgroundPosition: "center", backgroundRepeat: "no-repeat",maxWidth: "100%",height: "600px"}}>
      
        
        <p style={{fontFamily:"sans-serif",fontWeight:"bold",fontSize:"3rem",lineHeight:"1"}}>Recharge Made  <br/> <span style={{color:"#3399FF"}}> Simple</span></p>
        <p style={{fontFamily:"sans-serif",fontWeight:"lighter"}}>Experience the fastest and most secure way to <br/> recharge your mobile. Instant top-ups, secure <br/>payments, and complete transaction history at your <br/>fingertips. </p>
      
        <span style={{display:"flex",gap:"15px", alignItems:"center"}}>
        <a href="/mani-vasu.apk" style={{backgroundColor:"#007bff",color:"white",padding:"10px",borderRadius:"8px",textDecoration:"none"}}>Download now</a>

        <a href='' style={{textDecoration:"none",color:"grey"}}>
         <div style={{display:"flex",gap:"8px",alignItems:"center",alignContent:"center",backgroundColor:"white",padding:"10px",borderRadius:"8px"}}>
           <img src={playstore} alt="" style={{height:"20px",objectFit:"contain"}}/>
            <span style={{fontFamily:"sans-serif"}}>Google Play</span>
         </div>
         </a>
        </span>
      </div>

      {/* feature section*/}

    <section id="features" style={{backgroundColor:"#fafafada" ,padding:"40px 0 40px 0",}}>
      <div style={{display:"flex",flexDirection:"column",alignItems:"center"}}>

      <p style={{fontFamily:"sans-serif",fontWeight:"bold",fontSize:"1.5rem"}}>Powerful Features</p>
      <p style={{fontFamily:"sans-serif",textAlign:"center"}}>Everything you need for seamless mobile recharges, designed with <br/>simplicity and security in mind.</p>
      </div>

      {/* card section*/}
      <div style={{display:"flex", justifyContent:"space-around",flexWrap:"wrap"}} className='vertical-gap'>

      <div className='card-animate' style={{backgroundColor:"white",width:"250px",padding:"10px 20px 0px 20px",borderRadius:"20px"}}>
        <div>
          <img src={recharge} alt="" style={{height:"50px",width:"50px"}}/>
        </div>
        <p style={{fontSize:"1em",fontFamily:"sans-serif",fontWeight:"bold"}}>Quick Recharge</p>
        <p style={{fontSize:"0.8em",fontFamily:"sans-serif",fontWeight:"lighter",color:"grey"}}>Instant mobile recharges in just 3 taps. Support for all major carriers with real-time processing and immediate confirmation.</p>
      </div>
    
    
       <div className='card-animate' style={{backgroundColor:"white",width:"250px",padding:"10px 20px 0px 20px",borderRadius:"20px"}}>
        <div>
          <img src={secure} alt="" style={{height:"50px",width:"50px"}}/>
        </div>
        <p style={{fontSize:"1em",fontFamily:"sans-serif",fontWeight:"bold"}}>Secure Payments</p>
        <p style={{fontSize:"0.8em",fontFamily:"sans-serif",fontWeight:"lighter",color:"grey"}}>Bank-grade security with 256-bit encryption. Multiple payment options including cards, wallets, and UPI with fraud protection.</p>
      </div>

         <div className='card-animate' style={{backgroundColor:"white",width:"250px",padding:"10px 20px 0px 20px",borderRadius:"20px"}}>
        <div>
          <img src={transaction} alt="" style={{height:"50px",width:"50px"}}/>
        </div>
        <p style={{fontSize:"1em",fontFamily:"sans-serif",fontWeight:"bold"}}>Transaction History</p>
        <p style={{fontSize:"0.8em",fontFamily:"sans-serif",fontWeight:"lighter",color:"grey"}}>Complete transaction records with detailed receipts, spending analytics, and easy export options for better financial tracking.</p>
      </div>
      </div>

    </section>




    {/* How it works */}

    <section style={{backgroundColor:"white" ,padding:"40px 0 50px 0",}}>
      <div style={{display:"flex",flexDirection:"column",alignItems:"center"}}>

      <p style={{fontFamily:"sans-serif",fontWeight:"bold",fontSize:"1.5rem"}}>How It Works</p>
      <p style={{fontFamily:"sans-serif",textAlign:"center"}}>Experience the simplicity of mobile recharge in just a few steps</p>
      </div>

      {/* card section*/}
      <div style={{display:"flex", justifyContent:"space-around",flexWrap:"wrap"}} className='vertical-gap'>

      <div className='card-animate' style={{backgroundColor:"#fafafada",width:"250px",padding:"10px 20px 0px 20px",borderRadius:"20px"}}>
        <div>
          <img src={selectPlan} alt="" style={{height:"auto",width:"100%"}}/>
        </div>
        <p style={{fontSize:"1em",fontFamily:"sans-serif",fontWeight:"bold"}}>1. Select Your Carrier</p>
        <p style={{fontSize:"0.8em",fontFamily:"sans-serif",fontWeight:"lighter",color:"grey"}}>Choose from a wide range of supported mobile carriers. We partner with all major networks to ensure coverage for everyone.</p>
      </div>
    
    
       <div className='card-animate' style={{backgroundColor:"#fafafada",width:"250px",padding:"10px 20px 0px 20px",borderRadius:"20px"}}>
        <div>
          <img src={pay} alt="" style={{height:"auto",width:"100%"}}/>
        </div>
        <p style={{fontSize:"1em",fontFamily:"sans-serif",fontWeight:"bold"}}>2. Select Amount & Pay</p>
        <p style={{fontSize:"0.8em",fontFamily:"sans-serif",fontWeight:"lighter",color:"grey"}}>Choose your recharge amount and pay securely using your preferred payment method. Multiple options available.</p>
      </div>

         <div className='card-animate' style={{backgroundColor:"#fafafada",width:"250px",padding:"10px 20px 0px 20px",borderRadius:"20px"}}>
        <div>
          <img src={instantRecharge} alt=""style={{height:"auto",width:"100%"}}/>
        </div>
        <p style={{fontSize:"1em",fontFamily:"sans-serif",fontWeight:"bold"}}>3. Instant Recharge</p>
        <p style={{fontSize:"0.8em",fontFamily:"sans-serif",fontWeight:"lighter",color:"grey"}}>Your recharge is processed instantly. Get immediate confirmation and digital receipt for your records.</p>
      </div>
      </div>

      <div style={{display:"flex",justifyContent:"center", padding:"40px"}}>


          <button style={{ backgroundColor:"#007bff",color:"white",borderRadius:"8px",padding:"10px 15px 10px 15px"}}>Get Started</button>
      </div>


    </section>

    {/* why choose our app */}

    <section>
  <div
  id='benefits'
    style={{
      backgroundColor: "#fafafada",
      padding: "40px 0",
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
      justifyContent: "space-around",
    }}
    className='vertical-gap'
  >
    <span>
      <p
        style={{
          fontFamily: "sans-serif",
          fontWeight: "bold",
          fontSize: "1.5rem",
          marginBottom: "12px"
        }}
      >
        Why Choose Our App?

          

      </p>
        <div style={{display:"flex",alignItems:"center",alignContent:"center",gap:"8px"}}>
           <img src={playstore} alt="" style={{height:"20px",objectFit:"contain",}}/>

      <span
        style={{
          fontFamily: "sans-serif",
          fontWeight: "bold",
          fontSize: "1rem",
          // marginBottom: "4px",
        }}
        >
        Save Time
      </span>
       </div>
      <p
        style={{
          fontFamily: "sans-serif",
          fontWeight: "lighter",
          fontSize: "0.8em",
          color: "grey",
          marginTop: 0
        }}
        >
        Complete recharges in under 30 seconds with our streamlined process.
      </p>
     
          <div style={{display:"flex",alignItems:"center",alignContent:"center",gap:"8px"}}>
           <img src={playstore} alt="" style={{height:"20px",objectFit:"contain"}}/>

      <span
        style={{
          fontFamily: "sans-serif",
          fontWeight: "bold",
          fontSize: "1rem",
          // marginBottom: "4px",
        }}
        >
        Best Rates
      </span>
       </div>
      <p
        style={{
          fontFamily: "sans-serif",
          fontWeight: "lighter",
          fontSize: "0.8em",
          color: "grey",
          marginTop: 0
        }}
      >
       Competitive pricing with exclusive cashback offers and rewards.
      </p>
    </span>

    {/* ✅ Correct way to use imported image */}
    <img src={mobile} alt="App Preview" style={{ maxWidth:"400px" ,borderRadius:"16px"}} />
  </div>
</section>

<div id='get-started'>
<GetStarted />

</div>


<Footer />


    </div>
  )
}
